import {inject, Injectable} from '@angular/core';
import {loadStripe, Stripe} from '@stripe/stripe-js';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {ApiRoutesService} from './api-routes.service';
import {Observable} from 'rxjs';
import {PaymentStarted} from '../models/payment/payment-started.model';

@Injectable({
  providedIn: 'root'
})
export class StripeService {
  readonly #httpClient = inject(HttpClient);
  readonly #apiRoutes = inject(ApiRoutesService);

  #stripe: Promise<Stripe | null>;

  elements: any;

  constructor() {
    this.#stripe = loadStripe(environment.stripe_pk);
  }

  get stripe(): any {
    return this.#stripe;
  }

  startPaymentProcess(subscriptionId: string, communityId: string, couponId: string | undefined, paymentMethodId: string | undefined): Observable<PaymentStarted> {
    return this.#httpClient.post<PaymentStarted>(this.#apiRoutes.payments(), {subscriptionId, communityId, couponId, paymentMethodId});
  }
}
